module.exports = __webpack_public_path__ + "static/img/qr3.3074bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr3.png
// module id = 1269
// module chunks = 1